export default __webpack_public_path__ + "static/media/about-us-base-mobile.034b6882.jpg";